import { SunIcon, MoonIcon } from "@heroicons/react/24/solid";

export default function Header({ darkMode, toggleDarkMode }) {
  return (
    <header className="bg-amazon-dark sticky top-0 z-50 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-amazon-orange rounded-lg flex items-center justify-center">
              <span className="text-amazon-dark font-bold text-xl">E</span>
            </div>
            <div>
              <h1 className="text-white font-bold text-lg">The Essentials List</h1>
              <p className="text-gray-400 text-xs hidden sm:block">Curated Picks & Link Tools</p>
            </div>
          </div>

          <nav className="flex items-center space-x-4">
            <a
              href="#converter"
              className="text-gray-300 hover:text-amazon-orange px-3 py-2 text-sm font-medium transition-colors"
            >
              Link Generator
            </a>
            <a
              href="#categories"
              className="text-gray-300 hover:text-amazon-orange px-3 py-2 text-sm font-medium transition-colors hidden sm:block"
            >
              Browse Deals
            </a>
            <button
              onClick={toggleDarkMode}
              className="p-2 rounded-lg text-gray-300 hover:text-amazon-orange hover:bg-amazon-dark-lighter transition-all"
              aria-label="Toggle dark mode"
            >
              {darkMode ? (
                <MoonIcon className="h-5 w-5" />
              ) : (
                <SunIcon className="h-5 w-5" />
              )}
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
}
